export default "assets/images/icons/instagram-4fb94aee.svg";